import { useSubmenu } from '../hooks/useSubmenu';

type SubMenuWrapperProps = {
	children: React.ReactNode;
	blockClass?: string;
};

const SubMenuWrapper = ({ children }: SubMenuWrapperProps) => {
	const { blockClass } = useSubmenu();

	return (
		<div
			className={`vtex-menu-2-x-submenuWrapper submenuWrapper ${blockClass ? `vtex-menu-2-x-submenuWrapper--${blockClass} submenuWrapper--${blockClass}` : ''} vtex-menu-2-x-submenuWrapper--isOpen absolute left-0 bg-base pt4 pb4 bw1 bb b--muted-3 z-2 flex w-auto ml6`}
		>
			{children}
		</div>
	);
};

export default SubMenuWrapper;
